import React from "react";
import ChrWidgetHeaderFooterTemplate from "./Template/ChrWidgetHeaderFooterTemplate";

const ChrWidgetFooter = (props) => {
  return (
    <div className="d-flex flex-column mt-auto">
      <ChrWidgetHeaderFooterTemplate
        className='mt-auto'
        wrapperClass='border-top border-default'
        { ...props }
      />
    </div>
  )
}

export default ChrWidgetFooter;
